import { render, staticRenderFns } from "./account-information-settings-2-active-account-settings.vue?vue&type=template&id=6ac6c5da&"
import script from "./account-information-settings-2-active-account-settings.vue?vue&type=script&lang=ts&"
export * from "./account-information-settings-2-active-account-settings.vue?vue&type=script&lang=ts&"
import style0 from "./account-information-settings-2-active-account-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VDataTable,VIcon})
